var magicStyles = [".wrapper[data-v-0d6800bf]{display:grid;grid-template-columns:auto auto;gap:var(--magic-space,16px)}.text[data-v-0d6800bf]{margin-bottom:var(--magic-space--small,8px)}"];

export default magicStyles;
